export default "__VITE_ASSET__ddVsmyYr__"